import { Table } from '@material-ui/core'
import { parsePorcentagem } from 'helpers/formatador'
import { Dre } from 'models/Viabilidade/Dre'
import NumberFormat from 'react-number-format'
import {
  TableContainerCustomizado,
  TableCellLabel,
  TableRowCinza,
  TableRowBranca,
  TableRowVerde,
  TableCellValor,
  TableCellSubItem,
  TableCellBold,
  TableCellBoldAlignRight
} from '../index.style'

const CartaoDre: React.FC<{ dados: Dre }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableDre">
        <TableRowCinza>
          <TableCellLabel>+ Vendas</TableCellLabel>
          <TableCellValor data-cy="campoVendas">
            <NumberFormat
              value={dados.vendas}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellLabel>+ Permuta</TableCellLabel>
          <TableCellValor data-cy="campoPermuta">
            <NumberFormat
              value={dados.permuta}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- PDD</TableCellLabel>
          <TableCellValor data-cy="campoPdd">
            <NumberFormat
              value={dados.pdd}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>= Receita Bruta</TableCellLabel>
          <TableCellValor data-cy="campoReceitaBruta">
            <NumberFormat
              value={dados.receitaBruta}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellLabel>- PIS/Confis e ISS</TableCellLabel>
          <TableCellValor data-cy="campoPisCofinsIss">
            <NumberFormat
              value={dados.pisCofinsIss}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>= Receita Liquida</TableCellLabel>
          <TableCellValor data-cy="campoReceitaLiquida">
            <NumberFormat
              value={dados.receitaLiquida}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellSubItem>- Custo de Construção</TableCellSubItem>
          <TableCellValor data-cy="campoCustoConstrucao">
            <NumberFormat
              value={dados.custoConstrucao}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Terreno</TableCellSubItem>
          <TableCellValor data-cy="campoTerreno">
            <NumberFormat
              value={dados.terreno}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Urbanização</TableCellSubItem>
          <TableCellValor data-cy="campoUrbanizacao">
            <NumberFormat
              value={dados.urbanizacao}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- CI/CR</TableCellSubItem>
          <TableCellValor data-cy="campoCiCr">
            <NumberFormat
              value={dados.ciCr}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Custos Financeiro PJ</TableCellSubItem>
          <TableCellValor data-cy="campoCustosFinanceiroPj">
            <NumberFormat
              value={dados.custosFinanceiroPj}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Custos Financeiro Corporativo</TableCellSubItem>
          <TableCellValor data-cy="campoCustosFinanceiroCorporativo">
            <NumberFormat
              value={dados.custosFinanceiroCorporativo}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Assistencia Técnica</TableCellSubItem>
          <TableCellValor data-cy="campoAssistenciaTecnica">
            <NumberFormat
              value={dados.assistenciaTecnica}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Jurídico</TableCellSubItem>
          <TableCellValor data-cy="campoJuridico">
            <NumberFormat
              value={dados.juridico}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>- Segurança do Negócio</TableCellSubItem>
          <TableCellValor data-cy="campoSegurancaNegocio">
            <NumberFormat
              value={dados.segurancaNegocio}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>- Custo Total</TableCellLabel>
          <TableCellValor data-cy="campoCustoTotal">
            <NumberFormat
              value={dados.custoTotal}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowCinza>
          <TableCellLabel>= Lucro Bruto</TableCellLabel>
          <TableCellValor data-cy="campoLucroBruto">
            <NumberFormat
              value={dados.lucroBruto}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowVerde>
          <TableCellBold>Margem Bruta (%)</TableCellBold>
          <TableCellBoldAlignRight data-cy="campoMargemBruta">
            <NumberFormat
              value={parsePorcentagem(dados.margemBruta as string)}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              suffix="%"
              allowEmptyFormatting={true}
              defaultValue="-"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellBoldAlignRight>
        </TableRowVerde>
        <TableRowBranca>
          <TableCellLabel>+ Receita Financeira Líquida</TableCellLabel>
          <TableCellValor data-cy="campoReceitaFinanceiraLiquida">
            <NumberFormat
              value={dados.receitaFinanceiraLiquida}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- PDD Taxas</TableCellLabel>
          <TableCellValor data-cy="campoPddTaxas">
            <NumberFormat
              value={dados.pddTaxas}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- Outras Rec./Desp. Op.</TableCellLabel>
          <TableCellValor data-cy="campoOutrasReceitasDespesasOperacionais">
            <NumberFormat
              value={dados.outrasReceitasDespesasOperacionais}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- Despesas Financeiras</TableCellLabel>
          <TableCellValor data-cy="campoDespesasFinanceiras">
            <NumberFormat
              value={dados.despesasFinanceiras}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- Despesas Comercial</TableCellLabel>
          <TableCellValor data-cy="campoDespesasComerciais">
            <NumberFormat
              value={dados.despesasComerciais}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- Despesas Geral/Adm (G&A)</TableCellLabel>
          <TableCellValor data-cy="campoDespesasGeraisAdministrativas">
            <NumberFormat
              value={dados.despesasGeraisAdministrativas}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellLabel>- IR/CS</TableCellLabel>
          <TableCellValor data-cy="campoIrCs">
            <NumberFormat
              value={dados.irCs}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>= Lucro Líquido</TableCellLabel>
          <TableCellValor data-cy="campoLucroLiquido">
            <NumberFormat
              value={dados.lucroLiquido}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowVerde>
          <TableCellBold>Margem Líquida (%)</TableCellBold>
          <TableCellBoldAlignRight data-cy="campoMargemLiquida">
            <NumberFormat
              value={parsePorcentagem(dados.margemLiquida as string)}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              suffix="%"
              allowEmptyFormatting={true}
              defaultValue="-"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellBoldAlignRight>
        </TableRowVerde>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoDre
